import { useTypewriter } from './Typewriter.hooks';

export default function Typewriter({ children, active, ...props }) {
  const { ref, characters } = useTypewriter(children, active);
  return (
    <small ref={ ref } { ...props }>
      { characters.map(props => <span { ...props } />) }
    </small>
  );
};